export class ExportProjectExpenses {
    constructor(
        public id: number,
        public projectIds: number[],
        public expenseDateFrom?: string,
        public expenseDateTo?: string,
    ) {}
}
